import React from "react";
import ExternalLink from "./external-link";

export default () => {
    const whatsappGtag = () => {
        typeof window !== "undefined" && window.gtag &&
            window.gtag("event", "btn-whatsapp-contact-us", {
                event_category: "btn-whatsapp-contact-us",
                event_label: "whatsapp",
                debug_mode: process.env.GA_DEBUG_MODE || true,
            });
    };

    return (
        <div>
            <ExternalLink id="fake-chat" className="sb-ga-click float" onClick={() => whatsappGtag()} href="https://www.storeberry.ai/contact-us/whatsapp">
                <img src="https://assets.storeberry.ai/hk/legacy/img/whatsapp.svg" alt="whatsapp" />
            </ExternalLink>
        </div>
    );
};
